import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * React Router doesn't reset scroll position on navigation by default.
 * Mounted once inside <BrowserRouter>, this resets scroll to the top of
 * every new page so navigating (e.g. clicking a footer link while scrolled
 * down) doesn't land the user mid-page on the new route.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
